import { FC } from "react";
import { IconButton } from "@chakra-ui/react";

import { CloseIcon } from "@shared/components/Icons";

interface CaseDocumentRemoveFileButtonProps {
  fileName: string;
  disabled?: boolean;
  onClick: () => void;
}

const CaseDocumentRemoveFileButton: FC<CaseDocumentRemoveFileButtonProps> = ({ fileName, disabled, onClick }) => (
  <IconButton
    aria-label={`Remove ${fileName}`}
    variant="transparent"
    size="sm"
    minW="auto"
    h="auto"
    color="grey.10"
    _icon={{ boxSize: "12px" }}
    disabled={disabled}
    onClick={onClick}
  >
    <CloseIcon />
  </IconButton>
);

export default CaseDocumentRemoveFileButton;
